let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ei6X4")).then(() => parcelRequire('iAmkR'));